<template>
  <div class="pb-2">
    <Item 
      :text="cabinLabel"
      :price="cabinTotal"
      :main="true"
    />
    <Item
      v-for="(item, index) in cabinItems"
      :key="index"
      :text="item.label"
      :price="item.price"
    />
    <Item
      :text="transportationLabel"
      :price="transportationTotal.amount"
      :prefix="transportationTotal.prefix"
      :main="true"
      class="mt-2"
    />
    <Item
      v-for="(item, index) in transportationItems"
      :key="index"
      :text="item.label"
      :price="item.price"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { usePriceStore } from '@/store';
import { cabinLabel } from '@/store/details/price/getters';
import { mapState } from 'pinia';
import Item from './DetailsPriceSummaryItem.vue';

export default defineComponent({
  components: { Item },

  computed: {
    ...mapState(usePriceStore, {
      cabinLabel: store => store.cabinLabel,
      cabinItems: store => store.cabinItems,
      cabinTotal: store => store.cabinTotal,
      transportationLabel: store => store.transportationLabel,
      transportationItems: store => store.transportationItems,
      transportationTotal: store => store.transportationTotal
    }),
  },
})
</script>
